const translations = {
    mapErrorMessage: 'An error occurred while rendering the map. Reload the page to retry.',
    mapFailedToLoad: 'Map failed to load',
    reloadButton: 'Reload'
};

export default translations;
